export type IconProps = React.ComponentProps<'svg'>

export function DeleteIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6.7565 17.0832C6.38807 17.0832 6.07267 16.952 5.81031 16.6896C5.54794 16.4272 5.41675 16.1118 5.41675 15.7434V5.99984H4.95841C4.80494 5.99984 4.6763 5.94833 4.57248 5.8453C4.46866 5.74227 4.41675 5.6146 4.41675 5.4623C4.41675 5.30999 4.46866 5.18096 4.57248 5.0752C4.6763 4.96942 4.80494 4.91653 4.95841 4.91653H8.00006V4.66653C8.00006 4.48608 8.06392 4.332 8.19164 4.20428C8.31937 4.07656 8.47345 4.0127 8.65389 4.0127H11.3462C11.5267 4.0127 11.6808 4.07656 11.8085 4.20428C11.9362 4.332 12.0001 4.48608 12.0001 4.66653V4.91653H15.0417C15.1952 4.91653 15.3238 4.96805 15.4276 5.07109C15.5315 5.17412 15.5834 5.30179 15.5834 5.45409C15.5834 5.6064 15.5315 5.73543 15.4276 5.8412C15.3238 5.94696 15.1952 5.99984 15.0417 5.99984H14.5834V15.7344C14.5834 16.113 14.4522 16.4324 14.1898 16.6927C13.9274 16.953 13.6121 17.0832 13.2436 17.0832H6.7565ZM8.33662 14.4998H9.41994V7.49984H8.33662V14.4998ZM10.5802 14.4998H11.6635V7.49984H10.5802V14.4998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TrendingUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3.4 18L2 16.6L9.4 9.15L13.4 13.15L18.6 8H16V6H22V12H20V9.4L13.4 16L9.4 12L3.4 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EmojiPlusIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00575 17C6.9047 17 5.86806 16.7917 4.89583 16.375C3.92361 15.9583 3.07292 15.3854 2.34375 14.6562C1.61458 13.9271 1.04167 13.0767 0.625 12.105C0.208333 11.1334 0 10.0952 0 8.99046C0 7.88571 0.208333 6.85069 0.625 5.88542C1.04167 4.92014 1.61458 4.07292 2.34375 3.34375C3.07292 2.61458 3.92231 2.04167 4.89192 1.625C5.86153 1.20833 6.89756 1 8 1C8.51389 1 9.02431 1.04514 9.53125 1.13542C10.0382 1.22569 10.5278 1.36937 11 1.56644V3.22917C10.5278 2.99306 10.0417 2.8125 9.54167 2.6875C9.04167 2.5625 8.52778 2.5 8 2.5C6.19896 2.5 4.66537 3.13354 3.39923 4.40062C2.13308 5.66769 1.5 7.20242 1.5 9.00479C1.5 10.8072 2.13354 12.3403 3.40063 13.6042C4.66769 14.8681 6.20242 15.5 8.00479 15.5C9.80715 15.5 11.3403 14.8669 12.6042 13.6008C13.8681 12.3346 14.5 10.801 14.5 9C14.5 8.4686 14.4375 7.95381 14.3125 7.45563C14.1875 6.95743 14.0069 6.47222 13.7708 6H15.4375C15.6319 6.48611 15.7743 6.97917 15.8646 7.47917C15.9549 7.97917 16 8.48611 16 9C16 10.1024 15.7917 11.1385 15.375 12.1081C14.9583 13.0777 14.3854 13.9271 13.6562 14.6562C12.9271 15.3854 12.0783 15.9583 11.1099 16.375C10.1415 16.7917 9.10679 17 8.00575 17ZM14 4.5V3H12.5V1.5H14V0H15.5V1.5H17V3H15.5V4.5H14ZM10.75 8.25C11.0972 8.25 11.3924 8.12847 11.6354 7.88542C11.8785 7.64236 12 7.34722 12 7C12 6.65278 11.8785 6.35764 11.6354 6.11458C11.3924 5.87153 11.0972 5.75 10.75 5.75C10.4028 5.75 10.1076 5.87153 9.86458 6.11458C9.62153 6.35764 9.5 6.65278 9.5 7C9.5 7.34722 9.62153 7.64236 9.86458 7.88542C10.1076 8.12847 10.4028 8.25 10.75 8.25ZM5.25 8.25C5.59722 8.25 5.89236 8.12847 6.13542 7.88542C6.37847 7.64236 6.5 7.34722 6.5 7C6.5 6.65278 6.37847 6.35764 6.13542 6.11458C5.89236 5.87153 5.59722 5.75 5.25 5.75C4.90278 5.75 4.60764 5.87153 4.36458 6.11458C4.12153 6.35764 4 6.65278 4 7C4 7.34722 4.12153 7.64236 4.36458 7.88542C4.60764 8.12847 4.90278 8.25 5.25 8.25ZM8 13C8.83333 13 9.60069 12.7847 10.3021 12.3542C11.0035 11.9236 11.5556 11.3403 11.9583 10.6042H4.04167C4.44444 11.3403 4.99653 11.9236 5.69792 12.3542C6.39931 12.7847 7.16667 13 8 13Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PhotoPlusIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 14C1.0875 14 0.734375 13.8531 0.440625 13.5594C0.146875 13.2656 0 12.9125 0 12.5V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H8V1.5H1.5V12.5H12.5V6H14V12.5C14 12.9125 13.8531 13.2656 13.5594 13.5594C13.2656 13.8531 12.9125 14 12.5 14H1.5ZM11 4.5V3H9.5V1.5H11V0H12.5V1.5H14V3H12.5V4.5H11ZM2.5 11H11.5L8.5 7L6.25 10L4.75 8L2.5 11Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CopyIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3 18.5V16.5H5V18.5H3ZM3 15V13H5V15H3ZM3 11.5V9.5H5V11.5H3ZM6.5 22V20H8.5V22H6.5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM10 22V20H12V22H10ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20H5V22ZM13.5 22V20H15.5C15.5 20.55 15.3042 21.0208 14.9125 21.4125C14.5208 21.8042 14.05 22 13.5 22ZM3 8C3 7.45 3.19583 6.97917 3.5875 6.5875C3.97917 6.19583 4.45 6 5 6V8H3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function BadgeCuriousCrafterIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <path
        d="M450 877.451C358.53 858.221 280.89 818.8 219.19 760.24C164.49 708.331 120.61 639.781 88.7798 556.5C62.0798 486.641 42.9998 404.06 32.0898 311.05C24.5498 246.81 20.6998 178.03 20.0898 96.2305C70.1598 103.67 119.85 107.43 168.12 107.43C236.78 107.43 299.59 99.5505 349.77 84.6305C393.57 71.6105 427.15 53.7005 450 31.2305C472.85 53.7105 506.44 71.6205 550.23 84.6405C600.4 99.5505 663.22 107.44 731.88 107.44C780.16 107.44 829.84 103.68 879.91 96.2405C879.3 178.04 875.45 246.81 867.91 311.06C857 404.08 837.93 486.66 811.22 556.51C779.38 639.791 735.51 708.341 680.81 760.25C619.11 818.81 541.47 858.231 450 877.461V877.451Z"
        fill="#0C3BBE"
      />
      <path
        d="M450 57.8192C474.06 76.8592 505.67 92.2492 544.53 103.799C596.53 119.259 661.31 127.429 731.88 127.429C773.66 127.429 816.47 124.669 859.65 119.209C858.54 190.249 854.78 251.349 848.05 308.719C842.95 352.179 836.04 393.529 827.5 431.609C818.05 473.789 806.28 513.409 792.54 549.359C777.66 588.289 760 624.119 740.05 655.849C718.75 689.729 694.18 719.979 667.05 745.729C638.13 773.169 605.36 796.409 569.64 814.789C533.53 833.369 493.32 847.549 450.01 856.999C406.7 847.559 366.49 833.369 330.38 814.789C294.66 796.409 261.89 773.179 232.97 745.729C205.83 719.969 181.27 689.729 159.97 655.849C140.02 624.119 122.36 588.289 107.48 549.359C93.74 513.409 81.97 473.789 72.52 431.609C63.99 393.529 57.07 352.179 51.97 308.719C45.24 251.349 41.48 190.239 40.37 119.209C83.55 124.669 126.35 127.429 168.14 127.429C238.7 127.429 303.49 119.259 355.49 103.799C394.35 92.2492 425.97 76.8592 450.03 57.8192M450.03 0.209219C411.17 57.9092 300.36 87.4292 168.15 87.4292C114.47 87.4292 57.32 82.5692 0 72.7692C0 365.439 36.92 814.049 450 897.869C863.08 814.049 900 365.439 900 72.7592C842.69 82.5592 785.52 87.4192 731.88 87.4192C599.65 87.4192 488.86 57.9092 450 0.199219L450.03 0.209219Z"
        fill="white"
      />
      <path
        d="M405.363 589.355V582.892C405.529 552.897 408.346 529.033 413.815 511.301C419.45 493.569 427.404 479.317 437.679 468.545C447.953 457.608 460.465 447.582 475.214 438.467C485.323 432.17 494.355 425.293 502.309 417.835C510.43 410.212 516.81 401.76 521.45 392.48C526.09 383.034 528.41 372.511 528.41 360.91C528.41 347.819 525.345 336.467 519.213 326.855C513.081 317.243 504.795 309.786 494.355 304.483C484.08 299.18 472.563 296.528 459.802 296.528C448.036 296.528 436.85 299.097 426.244 304.234C415.804 309.206 407.104 316.829 400.143 327.104C393.349 337.213 389.537 350.056 388.709 365.634H300.214C301.043 334.147 308.666 307.797 323.084 286.585C337.667 265.373 356.89 249.464 380.754 238.858C404.783 228.252 431.299 222.949 460.3 222.949C491.952 222.949 519.793 228.5 543.822 239.604C568.017 250.707 586.827 266.533 600.25 287.082C613.839 307.466 620.633 331.661 620.633 359.668C620.633 378.56 617.568 395.463 611.436 410.378C605.47 425.293 596.935 438.55 585.832 450.151C574.729 461.751 561.554 472.108 546.308 481.223C532.885 489.509 521.864 498.126 513.247 507.075C504.795 516.024 498.498 526.547 494.355 538.645C490.378 550.577 488.306 565.326 488.14 582.892V589.355H405.363ZM448.616 744.469C433.702 744.469 420.858 739.166 410.086 728.56C399.315 717.954 393.929 705.027 393.929 689.781C393.929 674.866 399.315 662.106 410.086 651.5C420.858 640.894 433.702 635.591 448.616 635.591C463.365 635.591 476.126 640.894 486.898 651.5C497.835 662.106 503.304 674.866 503.304 689.781C503.304 699.89 500.735 709.088 495.598 717.374C490.626 725.66 483.997 732.288 475.711 737.26C467.591 742.066 458.559 744.469 448.616 744.469Z"
        fill="white"
      />
    </svg>
  )
}

export function BadgeCleverCrafterIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.45-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.23-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.98,175.6-56.69,245.45-31.84,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.35,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.53-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.35-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <g>
          <circle
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            cx="450"
            cy="452.57"
            r="135.47"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            d="m519.31,565.41v112.2c0,14.59-11.83,26.41-26.41,26.41h-85.79c-14.59,0-26.41-11.83-26.41-26.41v-112.2"
          />
        </g>
        <g>
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            x1="158.39"
            y1="455.51"
            x2="247.77"
            y2="455.51"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            x1="652.23"
            y1="455.51"
            x2="741.61"
            y2="455.51"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            x1="243.8"
            y1="249.31"
            x2="307"
            y2="312.51"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            x1="593"
            y1="312.51"
            x2="656.2"
            y2="249.31"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="70px"
            x1="450"
            y1="253.28"
            x2="450"
            y2="163.9"
          />
        </g>
      </g>
    </svg>
  )
}

export function BadgeSkillfulCrafterIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.45-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.24-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.98,175.6-56.69,245.45-31.83,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.35,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.53-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.35-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <g>
          <g>
            <path
              fill="#fff"
              strokeWidth="0px"
              d="m509.91,441.45l52.62-88.8c35.2,5.49,71.79-10.39,91.07-42.91,25.26-42.64,11.18-97.68-31.45-122.94-42.64-25.26-97.68-11.18-122.94,31.45-20.72,34.96-14.96,78.25,11.28,106.63l-50.73,47.46m36.43,34.03,43.55-164.11c12-20.26,38.16-26.95,58.42-14.95,20.26,12,26.95,38.16,14.95,58.42-12,20.26-38.16,26.95-58.42,14.95-20.26-12-26.95-38.16-14.95-58.42Z"
            />
            <polyline
              fill="#fff"
              strokeWidth="0px"
              points="409.63 441.49 309.59 697.48 326.03 751.77 459.8 526.02"
            />
          </g>
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m496.17,406.37l-87.2-81.45c26.22-28.41,31.94-71.7,11.2-106.64-25.29-42.62-80.35-56.66-122.97-31.37-42.62,25.3-56.66,80.35-31.37,122.97,19.29,32.51,55.9,48.36,91.1,42.84l236.79,398.96,16.4-54.31-113.96-291Zm-131.4-105.63c-20.25,12.02-46.41,5.35-58.43-14.9-12.02-20.25-5.35-46.41,14.9-58.43,20.25-12.02,46.41-5.35,58.43,14.9,12.02,20.25,5.35,46.41-14.9,58.43Zm95.03,161.01c-12.94,0-23.43-10.49-23.43-23.43s10.49-23.43,23.43-23.43,23.43,10.49,23.43,23.43-10.49,23.43-23.43,23.43Z"
          />
        </g>
      </g>
    </svg>
  )
}

export function BadgeMasterMakerIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.45-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.24-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.99,175.6-56.69,245.45-31.84,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.34,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.54-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.34-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <polygon
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          points="724.42 353.99 463.94 505.48 203.45 353.99 463.94 202.51 724.42 353.99"
        />
        <polygon
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          points="657.37 392.98 657.37 582.48 463.94 694.98 270.5 582.48 270.5 395.66 463.94 505.48 657.37 392.98"
        />
      </g>
    </svg>
  )
}

export function BadgeCreativeMentorIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.46-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.23-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.98,175.6-56.69,245.46-31.84,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.34,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.53-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.35-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <path
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          d="m608.84,228.31h-290.12c-43.42,0-78.62,35.2-78.62,78.62v164.31c0,43.42,35.2,78.62,78.62,78.62h64.39v138.54c0,12.37,15.35,18.1,23.45,8.75l137.89-147.3h64.39c43.42,0,78.62-35.2,78.62-78.62v-164.31c0-43.42-35.2-78.62-78.62-78.62Z"
        />
        <line
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          x1="357.11"
          y1="344.82"
          x2="570.2"
          y2="344.82"
        />
        <line
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          x1="357.11"
          y1="445"
          x2="509.16"
          y2="445"
        />
      </g>
    </svg>
  )
}

export function BadgeCraftHeroIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.46-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.23-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.98,175.6-56.69,245.46-31.84,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.35,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.53-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.35-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <polygon
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="60px"
          points="450 224.62 519.01 364.44 673.31 386.86 561.65 495.7 588.01 649.38 450 576.82 311.99 649.38 338.35 495.7 226.69 386.86 380.99 364.44 450 224.62"
        />
      </g>
    </svg>
  )
}

export function BadgeCraftMasterIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.46-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.24-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.98,175.6-56.69,245.46-31.83,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.35,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.53-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.35-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <g>
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m285.32,187.23s-27.25,44.12-14.75,84.15c12.49,40.04,59.99,60.83,59.99,60.83,0,0,27.25-44.12,14.75-84.15-12.49-40.04-59.99-60.83-59.99-60.83Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m199.32,295.55s-.86,51.85,30.35,79.87c31.21,28.02,82.66,21.6,82.66,21.6,0,0,.86-51.85-30.35-79.87-31.21-28.02-82.66-21.6-82.66-21.6Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m163.32,416.34s16.41,55.09,58.75,74.29c42.34,19.2,94.59-4.77,94.59-4.77,0,0-16.41-55.09-58.75-74.29-42.34-19.2-94.59,4.77-94.59,4.77Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m191.21,554.34s35.66,51.22,85.86,56.61c50.19,5.39,95.91-37.1,95.91-37.1,0,0-35.66-51.22-85.86-56.61-50.19-5.39-95.91,37.1-95.91,37.1Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m284.95,690.68s55.09,33.67,104.86,17.88c49.77-15.79,75.39-75.05,75.39-75.05,0,0-55.09-33.67-104.86-17.88-49.77,15.79-75.39,75.05-75.39,75.05Z"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="40px"
            d="m319.64,307.81c-23.02,53.03-33.61,141.26,2.26,202.07,32.47,55.03,82.78,89.63,147.25,105.35"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m642.93,187.23s27.25,44.12,14.75,84.15c-12.49,40.04-59.99,60.83-59.99,60.83,0,0-27.25-44.12-14.75-84.15,12.49-40.04,59.99-60.83,59.99-60.83Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m728.93,295.55s.86,51.85-30.35,79.87c-31.21,28.02-82.66,21.6-82.66,21.6,0,0-.86-51.85,30.35-79.87,31.21-28.02,82.66-21.6,82.66-21.6Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m764.93,416.34s-16.41,55.09-58.75,74.29c-42.34,19.2-94.59-4.77-94.59-4.77,0,0,16.41-55.09,58.75-74.29,42.34-19.2,94.59,4.77,94.59,4.77Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m737.04,554.34s-35.66,51.22-85.86,56.61c-50.19,5.39-95.91-37.1-95.91-37.1,0,0,35.66-51.22,85.86-56.61,50.19-5.39,95.91,37.1,95.91,37.1Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m643.3,690.68s-55.09,33.67-104.86,17.88c-49.77-15.79-75.39-75.05-75.39-75.05,0,0,55.09-33.67,104.86-17.88,49.77,15.79,75.39,75.05,75.39,75.05Z"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="40px"
            d="m608.61,307.81c23.02,53.03,33.61,141.26-2.26,202.07-32.47,55.03-82.78,89.63-147.25,105.35"
          />
        </g>
      </g>
    </svg>
  )
}

export function BadgeCraftGeniusIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 900">
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            fill="currentColor"
            strokeWidth="0px"
            d="m450,878.45c-91.47-19.23-169.11-58.65-230.81-117.21-54.7-51.91-98.58-120.46-130.41-203.74-26.7-69.86-45.78-152.44-56.69-245.46-7.54-64.24-11.39-133.02-12-214.82,50.07,7.44,99.76,11.2,148.03,11.2,68.66,0,131.47-7.88,181.65-22.8,43.8-13.02,77.38-30.93,100.24-53.4,22.85,22.48,56.44,40.39,100.23,53.41,50.17,14.91,112.99,22.8,181.65,22.8,48.28,0,97.96-3.76,148.03-11.2-.61,81.8-4.46,150.57-12,214.82-10.91,93.02-29.99,175.6-56.69,245.46-31.84,83.28-75.71,151.83-130.41,203.74-61.7,58.56-139.34,97.98-230.81,117.21Z"
          />
          <path
            fill="#fff"
            strokeWidth="0px"
            d="m450,58.82c24.06,19.04,55.67,34.43,94.53,45.98,52,15.46,116.78,23.63,187.35,23.63,41.78,0,84.59-2.76,127.77-8.22-1.11,71.04-4.87,132.14-11.6,189.51-5.1,43.46-12.01,84.81-20.55,122.89-9.45,42.18-21.22,81.8-34.96,117.75-14.88,38.93-32.54,74.76-52.49,106.49-21.3,33.88-45.87,64.13-73,89.88-28.92,27.44-61.69,50.68-97.41,69.06-36.11,18.58-76.32,32.76-119.63,42.21-43.31-9.44-83.52-23.63-119.63-42.21-35.72-18.38-68.49-41.61-97.41-69.06-27.14-25.76-51.7-56-73-89.88-19.95-31.73-37.61-67.56-52.49-106.49-13.74-35.95-25.51-75.57-34.96-117.75-8.54-38.08-15.45-79.43-20.55-122.89-6.73-57.37-10.49-118.48-11.6-189.51,43.18,5.46,85.98,8.22,127.77,8.22,70.56,0,135.34-8.17,187.35-23.63,38.86-11.55,70.48-26.94,94.54-45.98m0-57.61c-38.86,57.7-149.67,87.22-281.88,87.22C114.47,88.43,57.32,83.57,0,73.77,0,366.44,36.92,815.05,450,898.87c413.08-83.82,450-532.43,450-825.11-57.31,9.8-114.48,14.66-168.12,14.66-132.23,0-243.02-29.51-281.88-87.22h0Z"
          />
        </g>
      </g>
      <g id="Layer_1_copy_2" data-name="Layer 1 copy 2">
        <g>
          <circle
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            cx="279.67"
            cy="380.92"
            r="92.18"
          />
          <circle
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            cx="623.88"
            cy="380.92"
            r="92.18"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            d="m305.99,599.76c71.61,94.48,206,112.99,300.48,41.39"
          />
          <path
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            d="m537.89,383.02c-47.6-47.6-124.64-47.6-172.24,0"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            x1="140.8"
            y1="383.02"
            x2="177.69"
            y2="383.02"
          />
          <line
            fill="none"
            stroke="#fff"
            strokeMiterlimit="10"
            strokeWidth="60px"
            x1="722.31"
            y1="383.02"
            x2="759.2"
            y2="383.02"
          />
        </g>
      </g>
    </svg>
  )
}
